import React from 'react';
import { useSmartFilter } from 'SmartFilterProvider';
import MainHeader from 'components/templateParts/MainHeader';
import SearchBar from 'components/templateParts/SearchBar';
import SmartViewsSidebar from '../../../SmartViewsSidebar/SmartViewsSidebar'
import AddPostButton from '../../../ui_components/buttons/AddPostButton';
import ExportAllButton from '../../../ui_components/buttons/ExportAllButton';
import Footer from 'components/Footer/Footer';
import { BaseListComponent } from 'components/base'
import { tableColConfig, smartFilterConfig } from 'config/resources/collaboratorsResource';

const CollaboratorsList = (props) => {
  const smartFilter = useSmartFilter();
  const filters = smartFilter?.getFilter() || {};

  return (
    
    <div>
      <MainHeader title="Collaborators"
                  button={<AddPostButton title="Collaborators" href="/collaborators/create"/>}/>
      <SearchBar/>
      <SmartViewsSidebar isOpen={true}
                         resource="collaborators"
                         smartFilterConfig={smartFilterConfig}>
        <div className="mainContainer">
          <div className="mainContainer__inner">
            <BaseListComponent
              {...props}
              tableColConfig={tableColConfig}
              deleteConfirmationMessagePostfix="collaborator"
              toolbarExtraComponents={
                <ExportAllButton 
                  resource="collaborators/export"
                  filter={filters}
                />
              }
            />
          </div>
          <Footer/>
        </div>
      </SmartViewsSidebar>
    </div>
  );
}


export default CollaboratorsList;